import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { EmbedProvider } from './contexts/EmbedContext';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <EmbedProvider>
      <App />
    </EmbedProvider>
  </StrictMode>
);
